'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

/**
 *
 * @param {object} props
 * @param {string} props.imgUrl - The URL of the image to display
 * @param {HTMLImageElement['loading']} [props.loading] - The loading attribute for the image
 * @param {{sizes: string, srcSet: string}} [props.srcSetItems] - The srcSet and sizes attributes for the image
 * @returns {JSX.Element}
 */

var SplitBannerImage = function SplitBannerImage(props) {
  var imgUrl = props.imgUrl,
    loading = props.loading,
    srcSetItems = props.srcSetItems;
  var bannerImage = {
    backgroundImage: "url(".concat(imgUrl, ")")
  };
  return srcSetItems !== null && srcSetItems !== void 0 && srcSetItems.srcSet ? /*#__PURE__*/React__default.default.createElement("div", {
    className: "lanl-splitbanner-image-srcset",
    "data-testid": "lanl-splitbanner-image-srcset"
  }, /*#__PURE__*/React__default.default.createElement("img", {
    "data-testid": "lanl-splitbanner-image-srcset-img",
    src: imgUrl,
    sizes: srcSetItems.sizes || '(max-width: 1024px) 100vw, 50vw',
    srcSet: srcSetItems.srcSet,
    alt: "",
    loading: loading
  })) : /*#__PURE__*/React__default.default.createElement("div", {
    style: bannerImage,
    className: "lanl-splitbanner-image"
  });
};
SplitBannerImage.defaultProps = {};
SplitBannerImage.propTypes = {
  imgUrl: PropTypes__default.default.string,
  loading: PropTypes__default.default.oneOf(['eager', 'lazy']),
  srcSetItems: PropTypes__default.default.shape({
    sizes: PropTypes__default.default.string,
    srcSet: PropTypes__default.default.string
  })
};

exports.SplitBannerImage = SplitBannerImage;
exports.default = SplitBannerImage;
//# sourceMappingURL=SplitBannerImage.js.map
